/**
 * Unit Conversion Module — German locale (cm ↔ inches)
 * 
 * - Displays all measurement values in cm (rounded to whole numbers)
 * - Submits all measurement values in inches (Luxire production standard)
 * - Converts size chart values, dropdown labels, chips, and profile previews
 */
(function() {
  'use strict';
  if (document.documentElement.lang !== 'de') return;

  var CM_PER_INCH = 2.54;

  function inToCm(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return val;
    return Math.round(n * CM_PER_INCH);
  }

  /* ═══ 1. Standard Size Dropdowns ═══
   * Convert displayed labels from inches to cm.
   * Keep the value attribute in inches.
   */
  function convertDropdowns() {
    document.querySelectorAll('.measurement-panel__select').forEach(function(sel) {
      var name = sel.name || '';
      var isSize = name.indexOf('Standard Size') >= 0;
      var isInseam = name.indexOf('Standard Inseam') >= 0;
      var isNeck = name.indexOf('Neck Size') >= 0;
      var isSleeve = name.indexOf('Sleeve Length') >= 0;

      if (!isSize && !isInseam && !isNeck && !isSleeve) return;

      Array.from(sel.options).forEach(function(opt) {
        if (!opt.value) return;

        var inVal = parseFloat(opt.value.replace(/"/g, ''));
        if (isNaN(inVal)) return;

        var cmVal = inToCm(inVal);

        if (isSize && opt.textContent.indexOf('(') >= 0) {
          /* Waist size: "32 (Taille 86 cm)" */
          var parts = opt.textContent.split('(');
          var labelText = parts[1] ? parts[1].replace(/[\d.,]+\s*(Zoll|cm|inches)?\)?/g, '') : '';
          var waistIn = inVal + 2;
          opt.textContent = inVal + ' (' + labelText.trim() + ' ' + inToCm(waistIn) + ' cm)';
        } else if (isNeck || isSleeve) {
          /* Neck/sleeve: '15"' → '38 cm' */
          opt.textContent = cmVal + ' cm';
        } else {
          /* Inseam: '32 Zoll' → '81 cm' */
          opt.textContent = cmVal + ' cm';
        }
      });
    });
  }

  /* ═══ 2. Quick Size Chips ═══
   * Convert chip labels from inches to cm.
   */
  function convertChips() {
    document.querySelectorAll('.std-chip').forEach(function(chip) {
      var valAttr = chip.dataset.chipValue;
      if (!valAttr) return;
      var inVal = parseFloat(valAttr.replace('"', ''));
      if (isNaN(inVal)) return;

      var cmVal = inToCm(inVal);
      var mainSpan = chip.querySelector('.std-chip__main');
      if (mainSpan) {
        mainSpan.textContent = cmVal + ' cm';
      }
    });
  }

  /* ═══ 3. Size Chart Tables ═══
   * Convert all numeric cells in size chart tables.
   * Skip the first column (size label).
   */
  function convertChartTables() {
    ['ezs-pant-chart-table', 'ezs-shirt-chart-table'].forEach(function(id) {
      var table = document.getElementById(id);
      if (!table) return;
      convertTableCells(table);
    });
  }

  function convertTableCells(table) {
    /* Convert header labels */
    var headerMap = {
      'Size': 'Größe', 'Neck': 'Hals', 'Chest': 'Brust', 'Waist': 'Taille',
      'Bottom': 'Saum', 'Yoke': 'Sattel', 'Biceps': 'Bizeps', 'Cuff': 'Manschette',
      'Length': 'Länge', 'Collar': 'Kragen', 'Hip': 'Hüfte', 'Thigh': 'Oberschenkel',
      'Knee': 'Knie', 'Front Rise': 'Vord. Leibhöhe', 'Back Rise': 'Hint. Leibhöhe',
      'FR': 'VL', 'BR': 'HL'
    };
    table.querySelectorAll('thead th').forEach(function(th) {
      var txt = th.textContent.trim();
      if (headerMap[txt]) th.textContent = headerMap[txt];
    });

    /* Convert measurement values */
    table.querySelectorAll('tbody tr').forEach(function(tr) {
      var cells = tr.querySelectorAll('td');
      for (var i = 1; i < cells.length; i++) {
        var txt = cells[i].textContent.trim();
        var n = parseFloat(txt);
        if (!isNaN(n) && n > 0 && n < 100) {
          cells[i].textContent = inToCm(n);
        }
      }
    });
  }

  /* ═══ 4. Measurement Inputs ═══
   * Display unit label shows "cm". User enters values in cm directly.
   * No conversion needed — values are submitted as-is in cm.
   */

  /* ═══ 5. Saved Profile Preview ═══
   * Convert values displayed when a saved profile is selected.
   */
  function convertProfilePreview() {
    document.querySelectorAll('.mp-profile-preview__val').forEach(function(el) {
      var txt = el.textContent.trim();
      /* Match patterns like '17"' or '17 in' or '17"' */
      var match = txt.match(/^([\d.]+)\s*("| ?in| ?Zoll| ?cm)?$/);
      if (match) {
        var n = parseFloat(match[1]);
        if (!isNaN(n) && n < 80) { /* sanity check - inches are < 80 */
          el.textContent = inToCm(n) + ' cm';
        }
      }
    });
  }

  /* ═══ 6. Hook into chart rendering ═══
   * The charts are rendered by JS after page load. We need to convert
   * after they render.
   */
  function observeCharts() {
    ['ezs-pant-chart-table', 'ezs-shirt-chart-table'].forEach(function(id) {
      var table = document.getElementById(id);
      if (!table) return;
      var tbody = table.querySelector('tbody');
      if (!tbody) return;

      var observer = new MutationObserver(function() {
        convertTableCells(table);
      });
      observer.observe(tbody, { childList: true, subtree: true });
    });
  }

  /* ═══ 7. Hook into profile selection ═══ */
  function observeProfiles() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.addedNodes.length) {
          convertProfilePreview();
          /* Also convert any newly filled inputs */
          setTimeout(function() {
            document.querySelectorAll('.measurement-panel__input[data-unit-convert="cm"]').forEach(displayAsCm);
          }, 100);
        }
      });
    });

    document.querySelectorAll('.mp-profile-selector, .mp-profile-preview').forEach(function(el) {
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  /* ═══ INIT ═══ */
  function init() {
    convertDropdowns();
    convertChips();
    convertChartTables();
    observeCharts();
    observeProfiles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
